// @ts-check
import React, { useMemo } from 'react';
import { Text, TextVariants } from '@patternfly/react-core';
import { fontWeights, fontStyles } from 'utils/font';
import useMeasurementSystem from './useMeasurementSystem';

/**
 * @typedef {object} RenderComponentProps
 * @property {string} value
 * @property {import('utils/font').fontWeights} fontWeight
 * @property {import('utils/font').fontStyles} fontStyle
 */

/**
 * @param {RenderComponentProps} props
 */
const ValueText = ({ value, fontWeight, fontStyle }) => {
  return (
    <Text component={TextVariants.p} style={{ fontWeight: fontWeight, fontStyle: fontStyle }}>
      { value }
    </Text>
  );
};

/**
 * @typedef {object} ValueProps
 * @property {(import('utils/dtdl').DtdlTelemetry)|(import('utils/dtdl').DtdlProperty)} dtdlContent
 * @property {import('utils/dtdl').PrimitiveSchemas} value
 * @property {boolean} showUnit
 * @property {import('utils/font').fontWeights} fontWeight
 * @property {import('utils/font').fontStyles} fontStyle
 */

/**
 * Value component
 * @param {ValueProps} props
 */
const Value = ({ dtdlContent, value, showUnit = true, fontWeight = fontWeights.normal, fontStyle = fontStyles.normal }) => {
  const { convertToUserValue } = useMeasurementSystem({});
  const newValue = useMemo(() => convertToUserValue({ value, schemaUnit: dtdlContent, showUnit }), [value, dtdlContent, showUnit, convertToUserValue]);
  return <ValueText value={newValue} fontWeight={fontWeight} fontStyle={fontStyle} />;
};

export default Value;
